import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/exec.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm exec -- <pkg>[@<version>] [args...]
npm exec --package=<pkg>[@<version>] -- <cmd> [args...]
npm exec -c '<cmd> [args...]'
npm exec --package=foo -c '<cmd> [args...]'

alias: x
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/exec.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`This command allows you to run an arbitrary command from an npm package
(either one installed locally, or fetched remotely), in a similar context
as running it via `}<inlineCode parentName="p">{`npm run`}</inlineCode>{`.`}</p>
    <p>{`Run without positional arguments or `}<inlineCode parentName="p">{`--call`}</inlineCode>{`, this allows you to
interactively run commands in the same sort of shell environment that
`}<inlineCode parentName="p">{`package.json`}</inlineCode>{` scripts are run.  Interactive mode is not supported in CI
environments when standard input is a TTY, to prevent hangs.`}</p>
    <p>{`Whatever packages are specified by the `}<inlineCode parentName="p">{`--package`}</inlineCode>{` option will be
provided in the `}<inlineCode parentName="p">{`PATH`}</inlineCode>{` of the executed command, along with any locally
installed package executables.  The `}<inlineCode parentName="p">{`--package`}</inlineCode>{` option may be
specified multiple times, to execute the supplied command in an environment
where all specified packages are available.`}</p>
    <p>{`If any requested packages are not present in the local project
dependencies, then they are installed to a folder in the npm cache, which
is added to the `}<inlineCode parentName="p">{`PATH`}</inlineCode>{` environment variable in the executed process.  A
prompt is printed (which can be suppressed by providing either `}<inlineCode parentName="p">{`--yes`}</inlineCode>{` or
`}<inlineCode parentName="p">{`--no`}</inlineCode>{`).`}</p>
    <p>{`Package names provided without a specifier will be matched with whatever
version exists in the local project.  Package names with a specifier will
only be considered a match if they have the exact same name and version as
the local dependency.`}</p>
    <p>{`If no `}<inlineCode parentName="p">{`-c`}</inlineCode>{` or `}<inlineCode parentName="p">{`--call`}</inlineCode>{` option is provided, then the positional arguments
are used to generate the command string.  If no `}<inlineCode parentName="p">{`--package`}</inlineCode>{` options
are provided, then npm will attempt to determine the executable name from
the package specifier provided as the first positional argument according
to the following heuristic:`}</p>
    <ul>
      <li parentName="ul">{`If the package has a single entry in its `}<inlineCode parentName="li">{`bin`}</inlineCode>{` field in `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`,
or if all entries are aliases of the same command, then that command
will be used.`}</li>
      <li parentName="ul">{`If the package has multiple `}<inlineCode parentName="li">{`bin`}</inlineCode>{` entries, and one of them matches the
unscoped portion of the `}<inlineCode parentName="li">{`name`}</inlineCode>{` field, then that command will be used.`}</li>
      <li parentName="ul">{`If this does not result in exactly one option (either because there are
no bin entries, or none of them match the `}<inlineCode parentName="li">{`name`}</inlineCode>{` of the package), then
`}<inlineCode parentName="li">{`npm exec`}</inlineCode>{` exits with an error.`}</li>
    </ul>
    <p>{`To run a binary `}<em parentName="p">{`other than`}</em>{` the named binary, specify one or more
`}<inlineCode parentName="p">{`--package`}</inlineCode>{` options, which will prevent npm from inferring the package from
the first command argument.`}</p>
    <h3><inlineCode parentName="h3">{`npx`}</inlineCode>{` vs `}<inlineCode parentName="h3">{`npm exec`}</inlineCode></h3>
    <p>{`When run via the `}<inlineCode parentName="p">{`npx`}</inlineCode>{` binary, all flags and options `}<em parentName="p">{`must`}</em>{` be set prior to
any positional arguments.  When run via `}<inlineCode parentName="p">{`npm exec`}</inlineCode>{`, a double-hyphen `}<inlineCode parentName="p">{`--`}</inlineCode>{`
flag can be used to suppress npm's parsing of switches and options that
should be sent to the executed command.`}</p>
    <p>{`For example:`}</p>
    <pre><code parentName="pre" {...{}}>{`$ npx foo@latest bar --package=@npmcli/foo
`}</code></pre>
    <p>{`In this case, npm will resolve the `}<inlineCode parentName="p">{`foo`}</inlineCode>{` package name, and run the
following command:`}</p>
    <pre><code parentName="pre" {...{}}>{`$ foo bar --package=@npmcli/foo
`}</code></pre>
    <p>{`Since the `}<inlineCode parentName="p">{`--package`}</inlineCode>{` option comes `}<em parentName="p">{`after`}</em>{` the positional arguments, it is
treated as an argument to the executed command.`}</p>
    <p>{`In contrast, due to npm's argument parsing logic, running this command is
different:`}</p>
    <pre><code parentName="pre" {...{}}>{`$ npm exec foo@latest bar --package=@npmcli/foo
`}</code></pre>
    <p>{`In this case, npm will parse the `}<inlineCode parentName="p">{`--package`}</inlineCode>{` option first, resolving the
`}<inlineCode parentName="p">{`@npmcli/foo`}</inlineCode>{` package.  Then, it will execute the following command in that
context:`}</p>
    <pre><code parentName="pre" {...{}}>{`$ foo@latest bar
`}</code></pre>
    <p>{`The double-hyphen character is recommended to explicitly tell npm to stop
parsing command line options and switches.  The following command would
thus be equivalent to the `}<inlineCode parentName="p">{`npx`}</inlineCode>{` command above:`}</p>
    <pre><code parentName="pre" {...{}}>{`$ npm exec -- foo@latest bar --package=@npmcli/foo
`}</code></pre>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`package`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`The package or packages to install for `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-exec"
      }}><inlineCode parentName="a">{`npm exec`}</inlineCode></a></p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`call`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: ""`}</li>
      <li parentName="ul">{`Type: String`}</li>
    </ul>
    <p>{`Optional companion option for `}<inlineCode parentName="p">{`npm exec`}</inlineCode>{`, `}<inlineCode parentName="p">{`npx`}</inlineCode>{` that allows for specifying a
custom command to be run along with the installed packages.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm exec --package yo --package generator-node --call "yo node"
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`include-workspace-root`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Include the workspace root when workspaces are enabled for a command.`}</p>
    <p>{`When false, specifying individual workspaces via the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config, or
all workspaces via the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` flag, will cause npm to operate only on
the specified workspaces, and not on the root project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`Examples`}</h3>
    <p>{`Run the version of `}<inlineCode parentName="p">{`tap`}</inlineCode>{` in the local dependencies, with the provided
arguments:`}</p>
    <pre><code parentName="pre" {...{}}>{`$ npm exec -- tap --bail test/foo.js
$ npx tap --bail test/foo.js
`}</code></pre>
    <p>{`Run a command `}<em parentName="p">{`other than`}</em>{` the command whose name matches the package name
by specifying a `}<inlineCode parentName="p">{`--package`}</inlineCode>{` option:`}</p>
    <pre><code parentName="pre" {...{}}>{`$ npm exec --package=foo -- bar --bar-argument
# ~ or ~
$ npx --package=foo bar --bar-argument
`}</code></pre>
    <p>{`Run an arbitrary shell script, in the context of the current project:`}</p>
    <pre><code parentName="pre" {...{}}>{`$ npm x -c 'eslint && say "hooray, lint passed"'
$ npx -c 'eslint && say "hooray, lint passed"'
`}</code></pre>
    <h3>{`Workspaces support`}</h3>
    <p>{`You may use the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` or `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` configs in order to run an
arbitrary command from an npm package (either one installed locally, or fetched
remotely) in the context of the specified workspaces.
If no positional argument or `}<inlineCode parentName="p">{`--call`}</inlineCode>{` option is provided, it will open an
interactive subshell in the context of each of these configured workspaces one
at a time.`}</p>
    <p>{`Given a project with configured workspaces, e.g:`}</p>
    <pre><code parentName="pre" {...{}}>{`.
+-- package.json
\`-- packages
   +-- a
   |   \`-- package.json
   +-- b
   |   \`-- package.json
   \`-- c
       \`-- package.json
`}</code></pre>
    <p>{`Assuming the workspace configuration is properly set up at the root level
`}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file. e.g:`}</p>
    <pre><code parentName="pre" {...{}}>{`{
    "workspaces": [ "./packages/*" ]
}
`}</code></pre>
    <p>{`You can execute an arbitrary command from a package in the context of each of
the configured workspaces when using the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` configuration options,
in this example we're using `}<strong parentName="p">{`eslint`}</strong>{` to lint any js file found within each
workspace folder:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm exec --ws -- eslint ./*.js
`}</code></pre>
    <h4>{`Filtering workspaces`}</h4>
    <p>{`It's also possible to execute a command in a single workspace using the
`}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config along with a name or directory path:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm exec --workspace=a -- eslint ./*.js
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config can also be specified multiple times in order to run a
specific script in the context of multiple workspaces. When defining values for
the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config in the command line, it also possible to use `}<inlineCode parentName="p">{`-w`}</inlineCode>{` as a
shorthand, e.g:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm exec -w a -w b -- eslint ./*.js
`}</code></pre>
    <p>{`This last command will run the `}<inlineCode parentName="p">{`eslint`}</inlineCode>{` command in both `}<inlineCode parentName="p">{`./packages/a`}</inlineCode>{` and
`}<inlineCode parentName="p">{`./packages/b`}</inlineCode>{` folders.`}</p>
    <h3>{`Compatibility with Older npx Versions`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`npx`}</inlineCode>{` binary was rewritten in npm v7.0.0, and the standalone `}<inlineCode parentName="p">{`npx`}</inlineCode>{`
package deprecated at that time.  `}<inlineCode parentName="p">{`npx`}</inlineCode>{` uses the `}<inlineCode parentName="p">{`npm exec`}</inlineCode>{`
command instead of a separate argument parser and install process, with
some affordances to maintain backwards compatibility with the arguments it
accepted in previous versions.`}</p>
    <p>{`This resulted in some shifts in its functionality:`}</p>
    <ul>
      <li parentName="ul">{`Any `}<inlineCode parentName="li">{`npm`}</inlineCode>{` config value may be provided.`}</li>
      <li parentName="ul">{`To prevent security and user-experience problems from mistyping package
names, `}<inlineCode parentName="li">{`npx`}</inlineCode>{` prompts before installing anything.  Suppress this
prompt with the `}<inlineCode parentName="li">{`-y`}</inlineCode>{` or `}<inlineCode parentName="li">{`--yes`}</inlineCode>{` option.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`--no-install`}</inlineCode>{` option is deprecated, and will be converted to `}<inlineCode parentName="li">{`--no`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Shell fallback functionality is removed, as it is not advisable.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`-p`}</inlineCode>{` argument is a shorthand for `}<inlineCode parentName="li">{`--parseable`}</inlineCode>{` in npm, but shorthand
for `}<inlineCode parentName="li">{`--package`}</inlineCode>{` in npx.  This is maintained, but only for the `}<inlineCode parentName="li">{`npx`}</inlineCode>{`
executable.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`--ignore-existing`}</inlineCode>{` option is removed.  Locally installed bins are
always present in the executed process `}<inlineCode parentName="li">{`PATH`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`--npm`}</inlineCode>{` option is removed.  `}<inlineCode parentName="li">{`npx`}</inlineCode>{` will always use the `}<inlineCode parentName="li">{`npm`}</inlineCode>{` it ships
with.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`--node-arg`}</inlineCode>{` and `}<inlineCode parentName="li">{`-n`}</inlineCode>{` options are removed.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`--always-spawn`}</inlineCode>{` option is redundant, and thus removed.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`--shell`}</inlineCode>{` option is replaced with `}<inlineCode parentName="li">{`--script-shell`}</inlineCode>{`, but maintained
in the `}<inlineCode parentName="li">{`npx`}</inlineCode>{` executable for backwards compatibility.`}</li>
    </ul>
    <h3>{`A note on caching`}</h3>
    <p>{`The npm cli utilizes its internal package cache when using the package
name specified.  You can use the following to change how and when the
cli uses this cache. See `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-cache"
      }}><inlineCode parentName="a">{`npm cache`}</inlineCode></a>{` for more on
how the cache works.`}</p>
    <h4>{`prefer-online`}</h4>
    <p>{`Forces staleness checks for packages, making the cli look for updates
immediately even if the package is already in the cache.`}</p>
    <h4>{`prefer-offline`}</h4>
    <p>{`Bypasses staleness checks for packages.  Missing data will still be
requested from the server. To force full offline mode, use `}<inlineCode parentName="p">{`offline`}</inlineCode>{`.`}</p>
    <h4>{`offline`}</h4>
    <p>{`Forces full offline mode. Any packages not locally cached will result in
an error.`}</p>
    <h4>{`workspace`}</h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result to selecting all of the
nested workspaces)`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    <h4>{`workspaces`}</h4>
    <ul>
      <li parentName="ul">{`Alias: `}<inlineCode parentName="li">{`--ws`}</inlineCode></li>
      <li parentName="ul">{`Type: Boolean`}</li>
      <li parentName="ul">{`Default: `}<inlineCode parentName="li">{`false`}</inlineCode></li>
    </ul>
    <p>{`Run scripts in the context of all configured workspaces for the current
project.`}</p>
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-run-script"
        }}>{`npm run-script`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/scripts"
        }}>{`npm scripts`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-test"
        }}>{`npm test`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-start"
        }}>{`npm start`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-restart"
        }}>{`npm restart`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-stop"
        }}>{`npm stop`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/workspaces"
        }}>{`npm workspaces`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npx"
        }}>{`npx`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      